import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialBasicModule } from './modules/ui/material-basic.module';
import { MaterialLayoutModule } from './modules/ui/material-layout.module';
import { UnderConstructionComponent } from './shared/components/under-construction/under-construction.component';
import { AboutComponent } from './pages/about/about.component';
import { FleetComponent } from './pages/fleet/fleet.component';
import { CrewComponent } from './pages/crew/crew.component';
import { ReservationComponent } from './pages/reservation/reservation.component';
import { FlyConditionsComponent } from './pages/fly-conditions/fly-conditions.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AirplaneGalleryComponent } from './pages/fleet/airplane-gallery/airplane-gallery.component';
import { ImagePopupDialogComponent } from './shared/components/popup-image/popup-image.component';
import { TranslatingPageComponent } from './shared/components/translating-page/translating-page.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialFormsModule } from './modules/ui/material-forms.module';
import { HttpClientModule } from '@angular/common/http';
import { SummaryComponent } from './pages/summary/summary.component';
import { MatCarouselModule } from '@ngmodule/material-carousel';


@NgModule({
  declarations: [
    AppComponent,
    UnderConstructionComponent,
    AboutComponent,
    FleetComponent,
    CrewComponent,
    ReservationComponent,
    FlyConditionsComponent,
    PrivacyComponent,
    HomeComponent,
    PageNotFoundComponent,
    AirplaneGalleryComponent,
    ImagePopupDialogComponent,
    TranslatingPageComponent,
    SummaryComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialBasicModule,
    MaterialLayoutModule,
    FormsModule,
    MaterialFormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatCarouselModule.forRoot(),
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent],
  entryComponents: [ImagePopupDialogComponent]
})
export class AppModule { }
